import React from 'react';
import styled from '@emotion/styled';
import {size} from 'polished';

const svgIconSize = '1em';

const Icon = styled.span`
  ${size(svgIconSize)};
  display: inline-flex;
  align-self: center;

  svg {
    ${size(svgIconSize)};
    fill: currentcolor;
  }
`;

export default ({
  d,
  fill,
  fontSize = svgIconSize,
  width = 32,
  height = 32,
  style,
  transform,
  x = 0,
  y = 0,
  ...rest
}) => (
  <Icon {...rest} style={{fontSize, ...style}}>
    <svg
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox={`${x} ${y} ${width} ${height}`}
    >
      <path fill={fill || 'currentColor'} d={d} transform={transform} />
    </svg>
  </Icon>
);
